import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-required-fields-note',
  standalone: true,
  template: `
    <p
      class="tw-text-sm tw-text-[var(--sed-black-80-color)] tw-px-1"
      [class]="classes"
    >
      Fields marked with an asterisk (*) are required.
    </p>
  `,
})
export class RequiredFieldsNoteComponent {
  @Input()
  classes = 'tw-mb-1 ';
}
